import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type PublishAssignmentMutationVariables = Types.Exact<{
  data: Types.PublishAssignmentInput;
}>;


export type PublishAssignmentMutation = { publishAssignment: { assignment: { id: string, assignmentNumber: number } } };


export const PublishAssignmentDocument = /*#__PURE__*/ gql`
    mutation publishAssignment($data: PublishAssignmentInput!) {
  publishAssignment(data: $data) {
    assignment {
      id
      assignmentNumber
    }
  }
}
    `;

export function usePublishAssignmentMutation() {
  return Urql.useMutation<PublishAssignmentMutation, PublishAssignmentMutationVariables>(PublishAssignmentDocument);
};